import "core-js/modules/es.array.reduce.js";
import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import * as type from './type';
import * as utils from './index';
export var querySelector = function querySelector(selector, node) {
  if (type.isFunction(selector)) {
    return querySelector(selector(), node);
  }

  if (type.isNode(selector)) {
    return selector;
  }

  if (type.isString(selector)) {
    if (node && type.isNode(node)) {
      return node.querySelector(selector);
    } else {
      if (typeof document !== 'undefined') {
        return document.querySelector(selector);
      } else {
        return null;
      }
    }
  }

  if (Array.isArray(selector) || type.isNodeList(selector)) {
    return selector[0];
  }
};
export var querySelectorAll = function querySelectorAll(selector, node) {
  if (type.isFunction(selector)) {
    return selector(node ? node : typeof document !== 'undefined' ? document : null);
  }

  if (type.isString(selector)) {
    if (node && type.isNode(node)) {
      return node.querySelectorAll(selector);
    } else {
      if (typeof document !== 'undefined') {
        return document.querySelectorAll(selector);
      } else {
        return null;
      }
    }
  }

  if (type.isNode(selector)) {
    return [selector];
  }

  if (type.isNodeList(selector)) {
    return selector;
  }

  return null;
};
export var optionsFromDataset = function optionsFromDataset(node) {
  var defaultOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (type.isNode(node)) {
    return node.dataset ? Object.keys(node.dataset).filter(function (key) {
      return Object.keys(defaultOptions).includes(key);
    }).reduce(function (obj, key) {
      return _objectSpread(_objectSpread({}, obj), {}, _defineProperty({}, key, node.dataset[key]));
    }, {}) : {};
  } else {
    return {};
  }
};

if (typeof Node !== 'undefined' && !Node.prototype.on) {
  Node.prototype.on = function (names, handler) {
    var _this = this;

    if (!Array.isArray(names)) {
      names = names.split(' ');
    }

    names.forEach(function (name) {
      _this.addEventListener(name.trim(), handler, utils.detectSupportsPassive() ? {
        passive: false
      } : false);
    });
    return this;
  };
}

if (typeof NodeList !== 'undefined' && !NodeList.prototype.on) {
  NodeList.prototype.on = function (names, handler) {
    this.forEach(function (node) {
      node.on(names, handler);
    });
    return this;
  };
}

if (typeof Node !== 'undefined' && !Node.prototype.off) {
  Node.prototype.off = function (names, handler) {
    var _this2 = this;

    if (!Array.isArray(names)) {
      names = names.split(' ');
    }

    names.forEach(function (name) {
      _this2.removeEventListener(name.trim(), handler, utils.detectSupportsPassive() ? {
        passive: false
      } : false);
    });
    return this;
  };
}

if (typeof NodeList !== 'undefined' && !NodeList.prototype.off) {
  NodeList.prototype.off = function (names, handler) {
    this.forEach(function (node) {
      node.off(names, handler);
    });
    return this;
  };
}